

const STROKE = `fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"`;

export const HELP_CIRCLE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <circle cx="12" cy="12" r="9"/>
  <path d="M9.3 9.2a2.7 2.7 0 1 1 3.7 2.5c-.9.4-1.2 1-1.2 2"/>
  <line x1="12" y1="16.6" x2="12" y2="16.6"/>
</svg>`;

export const CALENDAR_LINE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <rect x="3" y="5" width="18" height="16" rx="3"/>
  <line x1="3" y1="10" x2="21" y2="10"/>
  <line x1="8" y1="3" x2="8" y2="7"/>
  <line x1="16" y1="3" x2="16" y2="7"/>
</svg>`;

export const CHAT_BUBBLE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <path d="M21 11.6a8.4 8.4 0 0 1-8.4 8.4 8.3 8.3 0 0 1-3.8-.9L3 21l1.9-5.7a8.3 8.3 0 0 1-.9-3.8A8.4 8.4 0 1 1 21 11.6z"/>
</svg>`;

export const CHEVRON_FORWARD = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <polyline points="9 6 15 12 9 18"/>
</svg>`;

export const MAIL_LINE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <rect x="3" y="5" width="18" height="14" rx="2"/>
  <path d="M3 7l9 6 9-6"/>
</svg>`;

export const PHONE_LINE = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ${STROKE}>
  <path d="M5 4h4l2 5-2.4 1.4a11.5 11.5 0 0 0 5 5L15.2 13l4.8 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-1z"/>
</svg>`;
